module.exports = __webpack_public_path__ + "static/classic-international-d5d5fb5eed22ef57800bd3acab776e1b.jpg";